import axios from "axios";
import { GLOBAL_URL } from "./constants";
import store from "reduxStore/store";
import { userLogout } from "reduxStore/action/authActions";
import {
  successToast,
  errorToast,
  warnToast,
  infoToast,
  greMobileOtpSettingToast,
} from "./toastNotify";

export {
  successToast,
  errorToast,
  warnToast,
  infoToast,
  greMobileOtpSettingToast,
};

const httpClient = axios.create({
  baseURL: `${GLOBAL_URL}/api/`,
});

export function setDefaultHeader(header, value) {
  httpClient.defaults.headers.common[header] = value;
}

export async function apiCall(
  method,
  url,
  data,
  header = {
    "Content-Type": "application/json",
  },
  options = {},
) {
  const controller = new AbortController();
  const { response } = store.getState().login;
  const isFormData =
    typeof FormData !== "undefined" && data instanceof FormData;

  let requestData = data;
  let skipGlobalLoader = false;

  // FormData (e.g. GRE banner upload) must pass through unchanged for multipart posts.
  if (!isFormData) {
    requestData = { ...(data || {}) };
    skipGlobalLoader =
      requestData.isLoadMore || requestData.suppressGlobalLoader;
    delete requestData.suppressGlobalLoader;
  }

  let headers = {
    ...header,
    token: response?.token,
  };

  if (isFormData) {
    // Let the browser set multipart boundary; do not force application/json.
    delete headers["Content-Type"];
  }

  const loaderElement = window.document.getElementById("loaderoverlay");
  if (!skipGlobalLoader && loaderElement) {
    loaderElement.style.display = "block";
  }
  const result = await httpClient({
    method,
    url,
    data: requestData,
    headers: headers,
    withCredentials: false,
    signal: controller.signal,
    responseType: options.responseType || "json",
    validateStatus:
      options.validateStatus ||
      ((status) => status >= 200 && status < 300),
  });
  if (result) {
    if (!skipGlobalLoader && loaderElement) {
      setTimeout(() => {
        loaderElement.style.display = "none";
      }, 1000);
    }
    return result;
  }
}

export const unAuthorizedError = (data) => {
  errorToast(data?.message || "Your session has expired.", {
    title: "Session expired",
    autoClose: 5000,
  });
  if (data.status === 401 || data.status === 400 || data.status === 403) {
    store.dispatch(userLogout());
    window.localStorage.clear();
    window.location.reload();
  }
};
